import { DataBean } from "../../../dataBean/DataBean";

export class SSTNode extends DataBean {

    public async getPHVARoot(idSSTPeriod: number): Promise<any> {
        return this.getCustomService("SafetyErp",
            "java.util.List_getPHVARoot_Number",
            [idSSTPeriod]
        );
    }
    public async getPHVAChildren(idParent: number): Promise<any> {
        return this.getCustomService("SafetyErp",
            "java.util.List_getPHVAChildren_Number",
            [idParent]
        );
    }
    public async importPHVA(idEmployee: number, media: string, mediaContext: string, idSSTPeriod: number): Promise<any> {
        return this.getCustomService("SafetyErp",
            "java.util.List_importPHVA_Number_String_String_Number",
            [idEmployee, media, mediaContext, idSSTPeriod]
        );
    }
    public async addFolderPHVA(idSSTPeriod: number, idParent: number, folderName: String, orderIndex: number, idEmployee: number): Promise<any> {
        return this.getCustomService("SafetyErp",
            "com.orange.people.sgsst.bean.SSTNode_addFolderPHVA_Number_Number_String_Number_Number",
            [idSSTPeriod, idParent, folderName, orderIndex, idEmployee]
        );
    }
    public async addDocumentPHVA(idSSTNode: number, media: string, mediaContext: string, fileName: string, versionNumber: number, idEmployee: number): Promise<any> {
        return this.getCustomService("SafetyErp",
            "com.orange.people.sgsst.bean.SSTNode_addDocumentPHVA_Number_String_String_String_Number_Number",
            [idSSTNode, media, mediaContext, fileName, versionNumber, idEmployee]
        );
    }

    public async deleteNodeSST(deleteNodeSST: number, IDSSTNode: number): Promise<any> {
        return this.getCustomService("SafetyErp",
            "Boolean_deleteNodeSST_Number_Number",
            [deleteNodeSST, IDSSTNode]
        );
    }
}